<div class="shadow" *ngIf="message.length > 0">
    <div class="message-modal">
        <span class="modal-title">Message:</span>
        <span>{{ message }}</span>
        <button (click)="onOk()"> Ok </button>
    </div>
</div>